import {yupResolver} from '@hookform/resolvers/yup'
import moment from 'moment'
import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import * as Yup from 'yup'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {InputTextArea} from '../../../../../../components/UI/Input'
import {Select} from '../../../../../../components/UI/Select'
import {SelectOption} from '../../../../../../models/utility.model'
import {getSnackBar} from '../../../../../../util/snackBar'
import {useCentralServices} from '../../../../hooks/useCentralServices'
import {downloadPDFCheckInOutService} from '../../../../services/booking.service'

interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  itemToEdit: any
  getBookings: () => void
}

const ModalRePrintCI: FC<Props> = ({show, setShow, itemToEdit, getBookings}) => {
  const {getMasterTable} = useCentralServices()
  const [showText, setShowText] = useState(false)
  const [reasons, setReasons] = useState<SelectOption[]>([])

  const isPrintable = itemToEdit.ImpresionCheckIn && itemToEdit.ImpresionCheckIn > 0

  const handleClose = () => {
    setShow(false)
  }

  const rePrintSchema = Yup.object().shape({
    MotivoReImpresionId: Yup.string().required('Motivo es requerido'),
  })

  const {
    register,
    reset,
    handleSubmit,
    // watch,
    control,
    setValue,
    setError,
    formState: {errors},
  } = useForm({
    resolver: yupResolver(rePrintSchema),
  })

  const onSubmit = async (datos: any) => {
    try {
      let dto = {
        reservaCamaId: itemToEdit.ReservaCamaId,
        tipo: 'IN',
        MotivoReimpresionId: datos?.MotivoReImpresionId,
        Otros: datos?.Otros,
      }
      const response = await downloadPDFCheckInOutService(dto)
      const blob = new Blob([response.data], {
        type: 'application/pdf',
      })
      // Crea un enlace temporal y simula un clic para descargar el archivo
      moment().format('DD/MM/YY HH:mm').toString()
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `CheckIn-${moment().format('DD/MM/YY HH:mm').toString()}.pdf` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      getSnackBar('Se descargó el documento con éxito', true)
      reset()
    } catch (error) {
      getSnackBar('Hubo un error al descargar', false)
    }
  }

  const getReasonsRePrint = async () => {
    const data = await getMasterTable('MotivoReimpresionReserva', true)
    setReasons(data)
  }

  const handleReasonsChange = (val: any) => {
    let value = val ? val.value : ''
    setValue('MotivoReImpresionId', value)
    if (value === 'vsjVgdF@bBw=') {
      setShowText(true)
    } else {
      setValue('Otros', '')
      setShowText(false)
    }
    setError('MotivoReImpresionId', {})
  }

  useEffect(() => {
    getReasonsRePrint()
  }, [])

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>ReImprimir CheckIn</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            {isPrintable ? (
              <div className='p-6'>
                <div className='d-flex'>
                  <div className='col-sm-6'>
                    <label>Motivo:</label>
                    <Select
                      control={control}
                      name='MotivoReImpresionId'
                      data={reasons}
                      errors={errors}
                      onChangeValue={handleReasonsChange}
                    />
                  </div>
                  {showText ? (
                    <div className='col-sm-6'>
                      <label>Otros:</label>
                      <InputTextArea
                        name='Otros'
                        textPlaceholder='Motivo por el cual desea re imprimir?'
                        register={register}
                        errors={errors}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ) : (
              <div>El checkIn aún no ha sido impreso</div>
            )}
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              {isPrintable ? (
                <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                  Imprimir
                </button>
              ) : (
                <></>
              )}
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalRePrintCI}
